import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Paths } from '../../utils/routerUrls';


function useDocumentTitle(title: string | undefined) {
  const { t } = useTranslation();
  const suffix = `${t('global:shortNames.beneficiary')} ${t('global:shortNames.system')}`;
  const route = window.location;
  const routePathName = route.pathname;

  useEffect(() => {
    if (title) {
      document.title = `${title}/${suffix}`;
    }

    return () => {
      if (title) {
        if (routePathName === Paths.roles) {
          document.title = `${t('global:sidebar.roles')}/${suffix}`;
        } else if (routePathName === Paths.users) {
          document.title = `${t('global:sidebar.users')}/${suffix}`;
        } else if (routePathName === Paths.examiners) {
          document.title = `${t('global:sidebar.examiners')}/${suffix}`;
        } else if (routePathName === Paths.cards) {
          document.title = `${t('global:sidebar.cards')}/${suffix}`;
        } else if (routePathName === Paths.sessions) {
          document.title = `${t('global:sidebar.sessions')}/${suffix}`;
        } else document.title = suffix;
      }
    };
  }, [title]);
}

export default useDocumentTitle;